import React from 'react'
import Menu from './Menu'
import Search from './Search'


const Header = () => {
  return (
    <div>
        <Menu />
        
        <Search />
    </div>
  )
}

export default Header
